$ {
    const fillThreshold = 0.25;
    const { imageId, imageSize, originalSize = {}, title = "", URL, useUrl, noScaling, ...attributes } = input;
    const ratio = originalSize.width < originalSize.height
        ? originalSize.width / originalSize.height
        : originalSize.height / originalSize.width;
    const imageClasses = [];
    imageClasses.push(originalSize.width > originalSize.height ? 'landscape' : 'portrait');
    if (noScaling) { imageClasses.push('no-scaling'); }
    if (1 - ratio <= fillThreshold) { imageClasses.push('zoom'); }
}

<${attributes.href ? "a" : "div"} ...attributes class=`str-image-square ${input.class || ""}`>
    <str-image ...input loading="lazy" class=imageClasses.join(" ") />
</>
